/* Street Garms SG-ANALYTICS-088 — GA4 bridge for SG-042 and SG-044.
 * SG-043 and SG-045 remain owned by sg-card-experiment.js.
 * This bridge also prevents SG-044's shared sg:pdp-add-to-cart CustomEvent from being
 * misclassified as an SG-043 GA4 event by the older central bridge.
 * SG-BOT-088: respects the confirmed analytics-bot suppression flag set in head_assets.liquid.
 */
(function () {
  'use strict';

  var GA4_DESTINATION = 'G-MEFN90HZPZ';

  if (window.__SG_CONFIRMED_ANALYTICS_BOT__ || window['ga-disable-' + GA4_DESTINATION]) {
    document.documentElement.setAttribute('data-sg-ga4-experiment-bridge', '088-filtered');
    return;
  }

  var pending = [];
  var flushTimer = null;
  var flushAttempts = 0;

  var routes = {
    'sg:hero-exposure': {
      experiment: 'SG-042',
      eventName: 'sg042_hero_exposure',
      variantParam: 'sg_hero_variant'
    },
    'sg:hero-cta-click': {
      experiment: 'SG-042',
      eventName: 'sg042_hero_cta_click',
      variantParam: 'sg_hero_variant'
    },
    'sg:reassurance-exposure': {
      experiment: 'SG-044',
      eventName: 'sg044_reassurance_exposure',
      variantParam: 'sg_reassurance_variant'
    },
    'sg:reassurance-link-click': {
      experiment: 'SG-044',
      eventName: 'sg044_reassurance_link_click',
      variantParam: 'sg_reassurance_variant'
    }
  };

  function scalarDetail(detail) {
    var params = {};
    detail = detail || {};
    Object.keys(detail).forEach(function (key) {
      var value = detail[key];
      if (value === null || value === undefined) return;
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        params[key] = value;
      }
    });
    return params;
  }

  function sendNow(eventName, params) {
    if (typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', eventName, params);
      return true;
    } catch (e) {
      return false;
    }
  }

  function flushPending() {
    flushTimer = null;
    if (typeof window.gtag === 'function') {
      var queued = pending.slice();
      pending = [];
      flushAttempts = 0;
      queued.forEach(function (entry) {
        sendNow(entry.eventName, entry.params);
      });
      return;
    }

    flushAttempts += 1;
    if (flushAttempts >= 20) {
      pending = [];
      return;
    }
    flushTimer = window.setTimeout(flushPending, 250);
  }

  function sendGa4(eventName, params) {
    if (window.__SG_CONFIRMED_ANALYTICS_BOT__ || window['ga-disable-' + GA4_DESTINATION]) return;
    params = Object.assign({}, params || {}, { send_to: GA4_DESTINATION });
    if (sendNow(eventName, params)) return;
    pending.push({ eventName: eventName, params: params });
    if (!flushTimer) flushTimer = window.setTimeout(flushPending, 250);
  }

  function sendRoutedEvent(event, route) {
    var detail = event && event.detail ? event.detail : {};
    var experiment = String(detail.experiment || '').toUpperCase();
    if (experiment !== route.experiment) return;

    var params = scalarDetail(detail);
    params.sg_experiment_id = experiment;
    if (detail.variant && route.variantParam) params[route.variantParam] = detail.variant;
    sendGa4(route.eventName, params);
  }

  Object.keys(routes).forEach(function (domEventName) {
    var route = routes[domEventName];
    window.addEventListener(domEventName, function (event) {
      sendRoutedEvent(event, route);
    });
  });

  // SG-043 and SG-044 historically share this CustomEvent name. Capture SG-044 first,
  // send it with its own taxonomy, then prevent the SG-043 bridge from relabelling it.
  window.addEventListener('sg:pdp-add-to-cart', function (event) {
    var detail = event && event.detail ? event.detail : {};
    if (String(detail.experiment || '').toUpperCase() !== 'SG-044') return;

    var params = scalarDetail(detail);
    params.sg_experiment_id = 'SG-044';
    if (detail.variant) params.sg_reassurance_variant = detail.variant;
    sendGa4('sg044_pdp_add_to_cart', params);

    if (event && typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }, true);

  document.documentElement.setAttribute('data-sg-ga4-experiment-bridge', '088');
})();
